var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-dropdown',{attrs:{"variant":"white","no-caret":"","offset":"-110"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('b-icon-three-dots-vertical')]},proxy:true}])},[_c('b-dropdown-item',{attrs:{"to":{
        name: 'ProductHistories',
        params: { id: _vm.stockDestination.variant.product.id }
      }}},[_vm._v(" Sincronizaciones ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }